import { RoutePath } from '@/config';
import { useAuthContext } from '@/hooks';

import type { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

interface Props {
  redirectPath?: RoutePath;
}

export const AuthRoute: FC<PropsWithChildren<Props>> = ({
  children,
  redirectPath = RoutePath.ClientCurrentOrder,
}) => {
  const { isAuthorized, isLoading } = useAuthContext();

  // Не делаем редирект пока идет загрузка
  if (isLoading) {
    return <>{children}</>;
  }

  if (isAuthorized) {
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};
